module.exports = __webpack_public_path__ + "static/Prof.ArnoldI.CaplanPhDUSA-38a0c561b2aa1c13df7e7fcd3bc24c4b.jpg";